import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { FiChevronDown } from 'react-icons/fi'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab5 = ({
    taxId,setTaxId,customerName,
    settaxCategory,taxcategory,taxcatlist,
    taxwithholdlist,setTaxwithholds,taxwithholds,
    price, setPrice, pricelist,
    gst,setGst,setPan,pan,
    GstCategorylist,setGstCategory,gstCategory
}) => {

    const [isGroup, setIsGroup] = useState(0)


    return (
       <div>
         <div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>

                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                            id="CustomerName"
                            label="Tax ID"
                            style={{ height: "30px" }}
                            value={taxId}
                            onChange={(e)=>setTaxId(e.target.value)}
                        />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={taxcatlist || []}
                                label="Tax Category"
                                value={taxcategory}
                                onChange={(val) => settaxCategory(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={taxwithholdlist || []}
                                label="Tax Withholding Category"
                                value={taxwithholds}
                                onChange={(val) => setTaxwithholds(val)}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="row mb-3 mt-5"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Tax Details</p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>

                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                             <Input
                            id="GSTIN / UIN"
                            label="GSTIN / UIN"
                            style={{ height: "30px" }}
                            value={gst}
                            onChange={(e)=>setGst(e.target.value)}
                        />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                             <Input
                            id="PAN"
                            label="PAN"
                            style={{ height: "30px" }}
                            value={pan}
                            onChange={(e)=>setPan(e.target.value)}
                        />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                             <SelectSearch
                            list={GstCategorylist || []}
                            label="GST Category"
                            value={gstCategory}
                            onChange={(val) => setGstCategory(val)}
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder=""
                        />
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
             <div className="">
                <ActivityCard doctype="Customer" docname={customerName} />
            </div>

       </div>


    )
}

export default Tab5